import React from 'react'
import { ForEachModel, useValue } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import DeliveryNoteColumns from './columns/DeliveryNoteColumns'
import InventoryDeliveryNoteItemFields from 'widgets/inventory/InventoryDeliveryNoteItemFields'
import ForEachOrderItemCategory from 'pages/app/inventory/order/partials/ForEachOrderItemCategory'

export default function DeliveryNoteOrderItems () {
  const status = useValue('status')

  return (
    <ForEachOrderItemCategory>
      <ForEachModel>
        <InventoryDeliveryNoteItemFields />
      </ForEachModel>
      <Table>
        <DeliveryNoteColumns orderStatus={status} />
      </Table>
    </ForEachOrderItemCategory>
  )
}
